import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

export const Title = styled.div`
  font-family: 'Roboto';
  font-style: italic;
  font-size: 16px;
  font-weight: 700;
  color: ${colors.green};
  margin-bottom: 20px;
  padding-left: 12px;
  padding-top: 10px;
`

export const Field = styled.div`
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: left;

  margin-bottom: 5px;
  padding-left: 12px;
`

export const Label = styled.div`
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: left;

  padding-bottom: 5px;
`

export const Value = styled.div`
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;

  margin-bottom: 20px;
  padding-left: 12px;
`
export const StyledContainerSwitch = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  /* padding-left: 12px; */
`
